import { useOutletContext, useParams } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import users from 'modules/core/store/collections/users'
import AccessGroup from 'modules/core/store/models/AccessGroup'

import employees from 'modules/employees/store/collections/employees'
import DynamicNewRespondent from 'modules/surveys/components/Participants/New/DynamicNewRespondent'
import ManualNewRespondent from 'modules/surveys/components/Participants/New/ManualNewRespondent'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import type Form from 'modules/surveys/store/models/Form'

const NewParticipantsPage = () => {
  const { navigation } = useNavigation()

  const { id } = useParams()
  const { survey, hasSurveyV2, canEditSurvey } = useSurveyShowContext()
  const { accessGroup, form } = useOutletContext<{ accessGroup: AccessGroup; form: Form }>()
  const surveyId = hasSurveyV2 && survey ? survey.attributes.id : form.attributes.id
  const back = navigation.engagement.surveys.id.participants.fullPath({ id: surveyId })
  const surveyStatus = hasSurveyV2 && survey ? survey.attributes.status : form.attributes.state

  const { loading } = useAsyncData(
    async () =>
      Promise.all([
        users.fetch({
          withCachedFetchParams: true,
        }),
        employees.fetch({ withCachedFetchParams: true }),
      ]),
    []
  )

  if (loading || !canEditSurvey) return null

  switch (accessGroup.attributes.strategy) {
    case AccessGroup.Strategies.members:
      return (
        <ManualNewRespondent
          users={users}
          employees={employees}
          accessGroup={accessGroup}
          surveyId={Number(id)}
          surveyStatus={surveyStatus}
          back={back}
        />
      )

    default:
      return (
        <DynamicNewRespondent
          accessGroup={accessGroup}
          surveyId={Number(id)}
          back={back}
          users={users}
          employees={employees}
        />
      )
  }
}

export default NewParticipantsPage
